// extracted by css-extract-rspack-plugin
export default {"container":"container-nGzVTF","contentContainer":"contentContainer-Y7kgmi","content":"content-ExNfXn","warningIcon":"warningIcon-goHmem"};